"use client";
import { useMutation } from "@tanstack/react-query";
import { postApiCcofPracticeIdCaptureConfirm } from "@/lib/api-client/endpoints/ccof-capture/ccof-capture";

/**
 * Confirms a card capture straight after the Stripe redirect via a single
 * synchronous request, replacing the previous client-side polling loop.
 */
export function useConfirmStaffCardCapture(practiceId: string) {
  return useMutation({
    mutationFn: async (setupIntentId: string) => {
      const response = await postApiCcofPracticeIdCaptureConfirm(practiceId, {
        setupIntentId,
      });
      return response.status === 200 ? response.data : undefined;
    },
  });
}
